"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _moment = _interopRequireDefault(require("moment"));
var _ykbUtils = require("ykb-utils");
var _Helpers = require("../Helpers");
var isCheckFilteredValue = function isCheckFilteredValue(original, columnId, filterValues) {
  if ((0, _ykbUtils.isNullOrUndefined)(original[columnId])) return false;
  var _filterValues = (0, _slicedToArray2.default)(filterValues, 4),
    type = _filterValues[0],
    props = _filterValues[1],
    columnDef = _filterValues[2],
    dates = _filterValues[3];
  var _dates$ = dates[0],
    endDate = _dates$.endDate,
    startDate = _dates$.startDate;
  var selectedFormat = _Helpers.Utils.getDateFormat(columnDef);
  var preparedValue = original[columnId];
  if (_moment.default.isMoment(preparedValue)) {
    return preparedValue.isBetween(startDate, endDate, undefined, '[]'); // true or false;
  }
  var value = String(preparedValue) || '';
  var isNumberValue = /[^0-9]/.test(value); // "123123123" => false, 123123123 => false, "123123123a" => true

  var parsedValue = isNumberValue ? (0, _moment.default)(value, selectedFormat) : _moment.default.unix(value);
  return parsedValue.isBetween(startDate, endDate, undefined, '[]'); // true or false;
};
var dateFilter = function dateFilter(row, filterValues) {
  var _filterValues2 = (0, _slicedToArray2.default)(filterValues, 3),
    _ = _filterValues2[0],
    props = _filterValues2[1],
    column = _filterValues2[2];
  var filteredValue = column.filteredValue || column.dataIndex;
  var exist = isCheckFilteredValue(row, filteredValue, filterValues);
  // let nestedExist = false;
  // if (!exist && Array.isArray(row.original.children)) {
  //   const list = Utils.flatten(row.original.children);
  //   nestedExist = list.some(item =>
  //     isCheckFilteredValue(item, filteredValue, filterValues)
  //   );
  // }

  // const isExpanded = row.getIsExpanded();
  // const returnVal = exist || nestedExist;
  // if (returnVal && !isExpanded) {
  //   const handleExpand = row.getToggleExpandedHandler();
  //   handleExpand();

  //   const filterData = Object.assign(row.original, { rowId: row.id });
  //   props?.onExpandByFilter(filterData);
  // }
  return exist;
};
var _default = exports.default = dateFilter;